import logoInstaller from '@/assets/logoInstaller.png';
import logoManager from '@/assets/logoManager.png';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import type { RequestConfig, RunTimeLayoutConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { Image } from 'antd';
import defaultSettings from '../config/defaultSettings';
import AwsCCP from './components/AwsCCP';
import { setupRedux } from './redux/setup';
import { getReduxStore, ReduxProvider } from './redux/store';
import { errorConfig } from './requestErrorConfig';
import { currentUser as queryCurrentUser } from './services/api';
import { redirectToLogin } from './utils/login';
const isDev = process.env.NODE_ENV === 'development';
const loginPath = '/user/login';
/**
 * @see  https://umijs.org/zh-CN/plugins/plugin-initial-state
 * */
export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  isOrganizationInfo?: any;
  menuCollapsed?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
  const fetchUserInfo = async () => {
    try {
      const msg = await queryCurrentUser({
        skipErrorHandler: true,
      });
      return msg.data;
    } catch (error) {
      console.log(error);
      // const {message, response}  = error;
      redirectToLogin();
    }
    return undefined;
  };

  const currentUser = await fetchUserInfo();

  //241010
  // const getOrganizationInfos = async () => {
  //   try {
  //     const msg = await getUserPermissions({});
  //     return msg.data;
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   return undefined;
  // };

  // const isOrganizationInfo = await getOrganizationInfos();
  //241010

  const isOrganizationInfo = true;

  // 创建Redux store
  const store = getReduxStore();
  // 初始化Redux
  setupRedux(store);

  //初始化menuCollapsed
  const menuCollapsed = false;
  return {
    menuCollapsed,
    fetchUserInfo,
    currentUser,
    isOrganizationInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

export function rootContainer(container: any) {
  const store = getReduxStore();
  return (
    <ReduxProvider store={store}>
      <AwsCCP />
      {container}
    </ReduxProvider>
  );
}

// 自定义钩子
// function useRuntimeLayoutConfig() {
//   const [collapsed, setCollapsed] = useState(false);
//   return { collapsed, setCollapsed };
// }

const thisLogo = APP_ROLE === 'manager' ? logoManager : logoInstaller;

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout: RunTimeLayoutConfig = ({ initialState, setInitialState }) => {
  console.log('initialState', initialState, setInitialState);
  return {
    ...initialState?.settings,
    logo: !initialState?.menuCollapsed ? (
      <div style={{ flex: 1, textAlign: 'center' }}>
        <Image src={thisLogo} width="198px" preview={false}></Image>
      </div>
    ) : (
      <span></span>
    ),
    collapsed: initialState?.menuCollapsed,
    collapsedButtonRender: (collapsed: any) => {
      console.log('collapsed', collapsed);
      return (
        <div className="collapsedButtonRender" onClick={() => setInitialState({ ...initialState, menuCollapsed: !collapsed })}>
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </div>
      );
    },
    menuHeaderRender: (thisLogo, title, props) => (props?.collapsed ? title : thisLogo),
    actionsRender: () => [],
    // avatarProps: {
    // src: initialState?.currentUser?.avatar,
    // title: <AvatarName />,
    // render: (_, avatarChildren) => {
    //   // return <AvatarDropdown menu>{avatarChildren}</AvatarDropdown>;
    // },
    // },
    // footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      // console.log('initialState3', initialState);
      console.log('location', location);
      console.log('loginPath', loginPath);
      // if (!initialState?.currentUser && location.pathname !== loginPath) {
      const a = sessionStorage.getItem('loginOut');
      if (!initialState?.currentUser && (!a || a !== '1')) {
        console.log('没有用户信息，提示无数据');
        history.push({
          pathname: `/noCurrentRole`,
        });
        // redirectToLogin();
      } else {
        sessionStorage.setItem('loginOut', '0');
      }
    },
    title: BASE_TITLE,
    bgLayoutImgList: [],
    links: [],
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {/* 该项目不存在根据build的命令来切换 process.env.NODE_ENV*/}
          {/* {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )} */}
        </>
      );
    },
  };
};

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request: RequestConfig = {
  baseURL: API_BASE_PATH,
  ...errorConfig,
};

/**
 * @name patchRoutes 配置，可以动态更新路由
 * 动态更新路由
 * @doc https://umijs.org/docs/api/runtime-config#patchroutes
 */

export function patchRoutes({ routes }: { routes: any }) {
  // 安装商端默认跳转到installer 241010
  let pagesRoutes = routes[1];
  if (APP_ROLE === 'installer') {
    pagesRoutes.redirect = '/business';
  }
  routes[1] = pagesRoutes;
}
